import client from './client';

const fileUrl = '/api/v1/file';

//파일 리스트 가져오기
export const getFiles = (params) => client.get(`${fileUrl}/list`, { params });

// 파일 추가 - FormData는 Content-Type을 설정하지 않아야 boundary가 자동 생성됨
export const addFiles = (formData) => {
  return client.post(`${fileUrl}/info`, formData);
};

//파일 정보
export const getFile = (id) => client.get(`${fileUrl}/info/${id}`);

export const editFile = (id, dataToSubmit) => {
  return client.put(`${fileUrl}/info/${id}`, dataToSubmit);
};

//파일 삭제
export const removeFile = (id) => client.delete(`${fileUrl}/info/${id}`);

//파일다운로드
export const downloadFile = (id) => {
  return client.get(`${fileUrl}/info/${id}/data`, {
    responseType: 'blob',
  });
};

//프로필 업로드
export const uploadProfile = (formData) => {
  return client.put(`${fileUrl}/profile`, formData);
};

/**
 * 프로필 이미지 URL 생성
 * 백엔드 API를 통해 프로필 이미지를 가져오기 위한 URL 반환
 * @param {string} usrUuid - 사용자 UUID
 * @returns {string} 프로필 이미지 API URL
 */
export const getProfileImageUrl = (usrUuid) => {
  if (!usrUuid) return null;
  return `${fileUrl}/profile/${usrUuid}/image`;
};

/**
 * 프로필 이미지 다운로드 (Blob)
 * axios를 통해 인증 토큰과 함께 프로필 이미지를 가져옴
 * @param {string} usrUuid - 사용자 UUID
 * @param {string} [cacheBust] - 이미지 변경 시 캐시 무효화용 값(예: profileImg URL)
 * @returns {Promise} Blob 응답
 */
export const getProfileImage = (usrUuid, cacheBust) => {
  const v = cacheBust ? `?v=${encodeURIComponent(cacheBust)}` : '';
  return client.get(`${fileUrl}/profile/${usrUuid}/image${v}`, {
    responseType: 'blob',
  });
};

//기술 파일 추가
export const addTechFiles = (formData) => {
  return client.post(`${fileUrl}/info/tech`, formData);
};

// 설계 파일 업로드
export const uploadDesignFile = (file, projectId, planId, designId, fileDesc = '') => {
  const formData = new FormData();
  formData.append('fileDt', file);
  formData.append('fileTyp', 'design');
  formData.append('fileAttrVal1', 'MANU');
  formData.append('fileAttrVal2', projectId || '');
  formData.append('fileAttrVal3', '설계');
  formData.append('fileAttrVal4', planId || '');
  formData.append('fileAttrVal5', designId || '');
  formData.append('fileDesc', fileDesc);
  
  return client.post(`${fileUrl}/info`, formData);
};

// 설계 파일 목록 조회
export const getDesignFiles = (designId) => {
  return client.get(`${fileUrl}/list`, {
    params: {
      fileAttrVal5: designId,
      fileAttrVal3: '설계',
    }
  });
};

// ===== 원자재 파일 =====
export const uploadMaterialFile = (file, projectId, planId, materialId, fileDesc = '') => {
  const formData = new FormData();
  formData.append('fileDt', file);
  formData.append('fileTyp', 'material');
  formData.append('fileAttrVal1', 'MANU');
  formData.append('fileAttrVal2', projectId || '');
  formData.append('fileAttrVal3', '원자재');
  formData.append('fileAttrVal4', planId || '');
  formData.append('fileAttrVal5', materialId || '');
  formData.append('fileDesc', fileDesc);
  
  return client.post(`${fileUrl}/info`, formData);
};

export const getMaterialFiles = (materialId) => {
  return client.get(`${fileUrl}/list`, {
    params: {
      fileAttrVal5: materialId,
      fileAttrVal3: '원자재',
    }
  });
};

// ===== 생산 파일 =====
export const uploadProductionFile = (file, projectId, planId, productionId, fileDesc = '') => {
  const formData = new FormData();
  formData.append('fileDt', file);
  formData.append('fileTyp', 'production');
  formData.append('fileAttrVal1', 'MANU');
  formData.append('fileAttrVal2', projectId || '');
  formData.append('fileAttrVal3', '생산');
  formData.append('fileAttrVal4', planId || '');
  formData.append('fileAttrVal5', productionId || '');
  formData.append('fileDesc', fileDesc);
  
  return client.post(`${fileUrl}/info`, formData);
};

export const getProductionFiles = (productionId) => {
  return client.get(`${fileUrl}/list`, {
    params: {
      fileAttrVal5: productionId,
      fileAttrVal3: '생산',
    }
  });
};

// ===== 공정 완료 파일 =====
export const uploadProcessFile = (file, planId, routingDetUuid, processNm, fileDesc = '') => {
  const formData = new FormData();
  formData.append('fileDt', file);
  formData.append('fileTyp', 'process');
  formData.append('fileAttrVal1', 'MANU');
  formData.append('fileAttrVal2', 'PROCESS');
  formData.append('fileAttrVal3', processNm || '공정');
  formData.append('fileAttrVal4', planId || '');
  formData.append('fileAttrVal5', routingDetUuid || '');
  formData.append('fileDesc', fileDesc);
  
  return client.post(`${fileUrl}/info`, formData);
};

export const getProcessFiles = (routingDetUuid) => {
  return client.get(`${fileUrl}/list`, {
    params: {
      fileAttrVal5: routingDetUuid,
      fileAttrVal2: 'PROCESS',
      fileTyp: 'process',
    }
  });
};

/**
 * 파일 찾기 — 영업이든 제조든 상관없이.
 *
 * 공통관리의 파일 찾기 화면과 채팅의 파일 넣기가 같은 것을 쓴다.
 *
 * @param {Object} params - { searchNm, searchCrtNm, fileTyp, strtDt, endDt, limit, offset }
 */
export const searchFiles = (params) => {
  return client.get(`${fileUrl}/search`, { params });
};

/**
 * 이 생산계획에 딸린 파일 전부.
 *
 * 제조 단계는 종류가 갈려도(설계 · 원자재 · 생산 · 공정 · QC · 생산완료 · 출하)
 * 전부 fileAttrVal4 에 생산계획 UUID 를 넣는다. 그래서 그것만으로 한 번에 모을 수 있다.
 *
 * 예전에는 공정을 하나씩 열어야 그 공정 파일이 보였다.
 * "이 계획에서 그동안 올린 것 전부" 를 볼 자리가 없었다.
 */
export const getFilesByPlan = (planId) => {
  return client.get(`${fileUrl}/list`, { params: { fileAttrVal4: planId } });
};

// ===== QC 파일 =====
export const uploadQCFile = (file, projectId, planId, qcId, fileDesc = '') => {
  const formData = new FormData();
  formData.append('fileDt', file);
  formData.append('fileTyp', 'qc');
  formData.append('fileAttrVal1', 'MANU');
  formData.append('fileAttrVal2', projectId || '');
  formData.append('fileAttrVal3', 'QC');
  formData.append('fileAttrVal4', planId || '');
  formData.append('fileAttrVal5', qcId || '');
  formData.append('fileDesc', fileDesc);
  
  return client.post(`${fileUrl}/info`, formData);
};

export const getQCFiles = (qcId) => {
  return client.get(`${fileUrl}/list`, {
    params: {
      fileAttrVal5: qcId,
      fileAttrVal3: 'QC',
    }
  });
};

// ===== 생산완료 파일 =====
export const uploadCompletionFile = (file, projectId, planId, completionId, fileDesc = '') => {
  const formData = new FormData();
  formData.append('fileDt', file);
  formData.append('fileTyp', 'completion');
  formData.append('fileAttrVal1', 'MANU');
  formData.append('fileAttrVal2', projectId || '');
  formData.append('fileAttrVal3', '생산완료');
  formData.append('fileAttrVal4', planId || '');
  formData.append('fileAttrVal5', completionId || '');
  formData.append('fileDesc', fileDesc);
  
  return client.post(`${fileUrl}/info`, formData);
};

export const getCompletionFiles = (completionId) => {
  return client.get(`${fileUrl}/list`, {
    params: {
      fileAttrVal5: completionId,
      fileAttrVal3: '생산완료',
    }
  });
};

// ===== 출하 파일 =====
export const uploadShipmentFile = (file, planId, shipmentId, fileDesc = '') => {
  const formData = new FormData();
  formData.append('fileDt', file);
  formData.append('fileTyp', 'shipment');
  formData.append('fileAttrVal1', 'MANU');
  formData.append('fileAttrVal2', 'SHIPMENT');
  formData.append('fileAttrVal3', '출하');
  formData.append('fileAttrVal4', planId || '');
  formData.append('fileAttrVal5', shipmentId || '');
  formData.append('fileDesc', fileDesc);

  return client.post(`${fileUrl}/info`, formData);
};

export const getShipmentFiles = (shipmentId) => {
  return client.get(`${fileUrl}/list`, {
    params: {
      fileAttrVal5: shipmentId,
      fileAttrVal2: 'SHIPMENT',
      fileTyp: 'shipment',
    }
  });
};
